export const OPEN_LOADING_PAGE = "OPEN_LOADING_PAGE";

export const CLOSE_LOADING_PAGE = "CLOSE_LOADING_PAGE";

export const SET_ALERT_MESSAGE = "SET_ALERT_MESSAGE";

export const SET_PRODUCT_PREVIOUS_ACTION = "SET_PRODUCT_PREVIOUS_ACTION";

export const SET_MENU_ACTIVE_ACTION = "SET_MENU_ACTIVE_ACTION";

export const SET_DELETE_PRODUCT_PREVIOUS_ACTION =
	"SET_DELETE_PRODUCT_PREVIOUS_ACTION";

export const SET_VALUE_SEARCH_PRODUCT_ACTION =
	"SET_VALUE_SEARCH_PRODUCT_ACTION";

export const GET_VALIDATE_LOGIN_FACE_ID_ACTION =
	"GET_VALIDATE_LOGIN_FACE_ID_ACTION";
export const SET_VALIDATE_LOGIN_FACE_ID_ACTION =
	"SET_VALIDATE_LOGIN_FACE_ID_ACTION";

export const SET_CHANGE_PASSWORD_ABOUT_TO_EXPIRE_ACTION =
	"SET_CHANGE_PASSWORD_ABOUT_TO_EXPIRE_ACTION";

export const SET_MESSAGE_CHANGE_PASSWORD = "SET_MESSAGE_CHANGE_PASSWORD";
